<template>
  <div class="tw-flex tw-flex-row tw-gap-2">
    {{ enumLabel }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  value: any;
  enumOptions: {
    label: string;
    value: string;
  }[];
}>();

const enumLabel = computed(() => {
  return props.enumOptions.find(option => option.value === props.value)?.label;
});
</script>
